<!--  -->
@let shippingConfirmationState = shippingConfirmationState$ | async;
<!--  -->
@if (!shippingConfirmationState?.loading && !shippingConfirmationState?.failed) {
<div class="shipping-confirmation-wrapper">
  <div class="shipping-confirmation-logotype">
    <peca-logotype color="dark" />
  </div>
  <div class="shipping-confirmation">
    <div class="shipping-confirmation__header">
      <h1 class="shipping-confirmation__header__title">{{ shipping.orderId }}</h1>
    </div>
    <div class="shipping-confirmation__content">
      <ul class="shipping-confirmation__content__stops">
        @for (stop of shipping.stops; track $index) {
        <li class="shipping-confirmation__content__stops__stop">
          <h2 class="shipping-confirmation__content__stops__stop__title">{{ stop | shippingStopKind : 'literal' }}</h2>
          <address class="shipping-confirmation__content__stops__stop__address">{{ stop.address }}</address>
        </li>
        }
      </ul>
    </div>
    <div class="shipping-confirmation__actions">
      <button class="ds-button --is-secondary" (click)="onClickConfirm()">iniciar viagem</button>
    </div>
  </div>
</div>
} @else if (shippingConfirmationState?.loading) {
<peca-shipping-loader />
} @else if (shippingConfirmationState?.failed) {
<peca-shipping-failed title="Falha ao iniciar a entrega" description="Não foi possível iniciar sua viagem. Tente novamente e caso o problema persistir, por favor, entre em contato com o suporte." (retry)="onRetry()" />
}
